import React from 'react'
import { ConversationMessageThread } from '../shared/ConversationMessageThread'
import { ConversationReviewTile } from './ConversationReviewTile'
import type { ConversationContentProps } from './ConversationContent'

export const IssueConversationContent: React.FC<ConversationContentProps> = ({
  conversation,
  onActiveIssueClick,
  onIssueStatusChange
}) => {
  const supplierLinkMode = conversation.issue?.supplierLinkMode

  return (
    <ConversationMessageThread
      messages={conversation.messages}
      firstGroupContent={(
        <ConversationReviewTile
          review={conversation.review}
          issueTrackingCTAMode='activeOnly'
          onActiveIssueClick={onActiveIssueClick}
          onIssueStatusChange={onIssueStatusChange}
          supplierLinkMode={supplierLinkMode}
        />
      )}
    />
  )
}
